var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRing1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 312,
    viewBox: "0 0 312 312",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4629 247.208C13.6421 224.056 3.55125 196.704 1.30598 168.175C-0.939299 139.646 4.74847 111.051 17.7405 85.5532C30.7324 60.055 50.5225 38.6462 74.9228 23.6938C99.323 8.74129 127.383 0.827609 156 0.827637L156 31.8621C133.106 31.8621 110.658 38.193 91.1382 50.155C71.618 62.117 55.786 79.244 45.3924 99.6425C34.9988 120.041 30.4486 142.917 32.2448 165.74C34.041 188.563 42.1137 210.445 55.5703 228.966L30.4629 247.208Z",
    fill: "#0038FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156 0.827637C175.558 0.827637 194.939 4.5248 213.123 11.7244L201.698 40.5795C187.151 34.8198 171.646 31.8621 156 31.8621L156 0.827637Z",
    fill: "#0038FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156 0.827637C175.558 0.827637 194.939 4.5248 213.123 11.7244L201.698 40.5795C187.151 34.8198 171.646 31.8621 156 31.8621L156 0.827637Z",
    fill: "#FF4C19"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M212.871 11.6249C249.906 26.2133 279.918 54.4759 296.703 90.5686L268.562 103.655C255.135 74.7807 231.125 52.1706 201.497 40.4999L212.871 11.6249Z",
    fill: "#0038FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M212.871 11.6249C249.906 26.2133 279.918 54.4759 296.703 90.5686L268.562 103.655C255.135 74.7807 231.125 52.1706 201.497 40.4999L212.871 11.6249Z",
    fill: "#FF4C19",
    fillOpacity: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M303.578 203.951C294.735 231.168 278.537 255.409 256.776 273.994C235.016 292.579 208.539 304.785 180.274 309.262C152.009 313.739 123.057 310.312 96.6181 299.361C70.1792 288.409 47.2837 270.36 30.4629 247.208L55.5703 228.966C69.027 247.488 87.3434 261.927 108.495 270.689C129.646 279.45 152.808 282.191 175.419 278.61C198.031 275.028 219.213 265.264 236.621 250.395C254.03 235.527 266.988 216.134 274.062 194.361L303.578 203.951Z",
    fill: "#0038FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M303.578 203.951C294.735 231.168 278.537 255.409 256.776 273.994C235.016 292.579 208.539 304.785 180.274 309.262C152.009 313.739 123.057 310.312 96.6181 299.361C70.1792 288.409 47.2837 270.36 30.4629 247.208L55.5703 228.966C69.027 247.488 87.3434 261.927 108.495 270.689C129.646 279.45 152.808 282.191 175.419 278.61C198.031 275.028 219.213 265.264 236.621 250.395C254.03 235.527 266.988 216.134 274.062 194.361L303.578 203.951Z",
    fill: "#FF4C19",
    fillOpacity: 0.28
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M296.404 89.9308C313.209 125.642 315.774 166.415 303.578 203.951L274.062 194.361C283.819 164.332 281.767 131.714 268.323 103.145L296.404 89.9308Z",
    fill: "#0038FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M296.404 89.9308C313.209 125.642 315.774 166.415 303.578 203.951L274.062 194.361C283.819 164.332 281.767 131.714 268.323 103.145L296.404 89.9308Z",
    fill: "#FF4C19",
    fillOpacity: 0.64
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing1);
export default __webpack_public_path__ + "static/media/ring-1.882b6dfbb8d11d7e7e6bf7738f3b7fb7.svg";
export { ForwardRef as ReactComponent };